import script from "./FooterCom.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterCom.vue?vue&type=script&setup=true&lang=js"

import "./FooterCom.vue?vue&type=style&index=0&id=fad91e60&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fad91e60"]])

export default __exports__